/** @jsx jsx */
import { forwardRef } from 'react';
import { jsx } from '@emotion/core';
import { containerStyles } from './styles';
var TagGroup = /*#__PURE__*/forwardRef(function (props, ref) {
  var _props$alignment = props.alignment,
      alignment = _props$alignment === void 0 ? 'start' : _props$alignment,
      children = props.children;
  return jsx("div", {
    ref: ref,
    css: containerStyles(alignment)
  }, children);
});
export default TagGroup;